import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import { useEsc } from 'hooks/useEsc';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Platform } from 'react-native';
import { WebView } from 'react-native-webview';
import { NAVIGATE_MODAL_BACK } from 'store/actions';
import { PageHeader } from 'components/PageHeader';

const HTML_DATA_URL_PREFIX = 'data:text/html';

function getInlineHtml(sourceUrl: string): string | null {
  if (!sourceUrl.startsWith(HTML_DATA_URL_PREFIX)) {
    return null;
  }

  const dataIndex = sourceUrl.indexOf(',');
  if (dataIndex === -1) {
    return null;
  }

  return decodeURIComponent(sourceUrl.slice(dataIndex + 1));
}

export const WebViewerScreen: React.FC<
  ModalScreenProps<ModalScreens.WEBVIEWER>
> = ({ route }) => {
  const dispatch = useDispatch();
  const { title, sourceUrl } = route.params;
  const inlineHtml = getInlineHtml(sourceUrl);

  const handleClose = React.useCallback(
    () => dispatch(NAVIGATE_MODAL_BACK()),
    [dispatch],
  );

  useEsc(sourceUrl ? handleClose : undefined);

  if (!sourceUrl) {
    return null;
  }

  return (
    <Page
      header={
        <PageHeader
          title={title}
          onPressCloseButton={() => dispatch(NAVIGATE_MODAL_BACK())}
        />
      }
    >
      {Platform.OS === 'web' ? (
        <iframe
          title={title}
          src={inlineHtml ? undefined : sourceUrl}
          srcDoc={inlineHtml || undefined}
          height="100%"
          width="100%"
          style={{ border: 0 }}
        />
      ) : (
        <WebView
          originWhitelist={['*']}
          source={inlineHtml ? { html: inlineHtml } : { uri: sourceUrl }}
          style={{ flex: 1 }}
        />
      )}
    </Page>
  );
};
